module.exports = __webpack_public_path__ + "img/apple-store-badge.baa50ca4.svg";